<template>
  <v-textarea
    v-model="modelValue"
    outlined
    hide-details="auto"
    :disabled="disabled"
    :label="label"
    :placeholder="placeholder"
    :persistent-placeholder="!!placeholder"
    :rules="rules"
    :rows="rows"
    :no-resize="!resizable"
    data-textarea-input
    :counter="limit"
    :maxlength="limit"
    :hint="hint"
    :persistent-hint="!!hint"
    v-on="$listeners"
  />
</template>

<script>
import { PropOptions, ComputedOptions } from 'vue'

export default {
  name: 'LongTextInputComponent',
  props: {
    value: {
      type: String,
      validator: (v) => typeof v === 'string' || v === null,
    },
    label: {
      type: String,
      default: null,
    },
    placeholder: {
      type: String,
      default: null,
    },
    rows: {
      type: Number,
      default: 4,
    },
    /** @type {PropOptions<Array<(v: any) => boolean | string>>} */
    rules: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    resizable: {
      type: Boolean,
      default: false,
    },
    limit: {
      type: Number,
      default: null,
    },
    hint: {
      type: String,
      default: null,
    },
  },
  computed: {
    /** @type {ComputedOptions<string>} */
    modelValue: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      },
    },
  },
}
</script>

<style scoped>
:deep(.v-label),
:deep(textarea) {
  font-size: 14px;
}
:deep(.v-input__slot) {
  min-height: 48px !important;
}
:deep(.v-label--active) {
  transform: translateY(-10px) scale(0.85) !important;
}
</style>
